<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start mb-md-0"
          >
            <b-button
                variant="success"
                class=""
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="downloadFile"
            >
              دانلود اکسل لیست
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <div>
      <!-- Table Container Card -->
      <b-card
          class="mb-0"
          no-body
      >
        <b-table
            ref="refUserListTable"
            :fields="myTableColumns"
            :items="users"
            bordered
            class="position-relative"
            empty-text="موردی یافت نشد."
            primary-key="id"
            responsive
            show-empty
            striped
        >

          <template #cell(userInfo.userId)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    :src="`https://api.banafshebagheri.com/media/gallery/profile/${data.item.userInfo.selfieFileData}`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                    :variant="`success`"
                    size="45"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.userInfo.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.userInfo.name + ' ' + data.item.userInfo.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userInfo.userId }}</small>
            </b-media>
          </template>

          <template #cell(isPayed)="data">
            <span v-if="data.item.isPayed" class="text-success">پرداخت شده</span>
            <span v-else class="text-danger">پرداخت نشده</span>
          </template>

          <template #cell(createDate)="data">
          <span>
            {{ new Date(data.item.createDate).toLocaleTimeString('fa-IR') }}
            -
            {{ new Date(data.item.createDate).toLocaleDateString('fa-IR') }}
          </span>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BAvatar, BButton,
  BCard,
  BCol, BFormInput,
  BLink,
  BMedia,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {OrderGetUsageCouponListRequest} from "@/libs/Api/Order";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "CouponUsed",
  title: "مصرف کنندگان کوپن - پنل ادمین بنفشه باقری",
  data() {
    return {
      users: [],
      couponId: this.$route.params.id,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      overlay: false,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'userFullName', label: 'اطلاعات کاربر'},
        {key: 'userNationalId', label: 'کد ملی'},
        {key: 'userMobile', label: 'موبایل'},
        {key: 'productTitle', label: 'محصول'},
        {key: 'isPayed', label: 'وضعیت'},
        {key: 'createDate', label: 'تاریخ و زمان استفاده'},
      ],
      searchCommand: '',
      isAddNewUserSidebarActive: false,
    }
  },
  async created() {
    await this.getUsers()
  },
  methods: {
    refreshData() {
      this.getStudents(this.perPage, this.currentPage, this.productId)
    },
    async getUsers() {
      let _this = this;
      _this.overlay = true;

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        couponId: _this.couponId
      }

      let orderGetUsageCouponListRequest = new OrderGetUsageCouponListRequest(_this);
      orderGetUsageCouponListRequest.setParams(data);
      await orderGetUsageCouponListRequest.fetch(function (content) {
        _this.overlay = false;
        _this.users = content.data;
        _this.totalCounts = content.total;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post("/Order/GetUsageCouponListExcel", null, {
        params: {
          couponId: _this.couponId
        },
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست مصرف کنندگان.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getUsers();
    },
  },
  components: {
    BFormInput, BButton,

    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BPagination,
    BOverlay,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
